import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { canUserAddBankAccounts } from '../../../common/helpers/users';
import {
  getInstantPayoutIsFetching,
  getTotalBalance,
  getShouldShowDebitCard,
} from '../selectors';
import AddBarberPrefix from '../../../common/RoleAwareLink';
import Money from '../../../common/money';
import SingleBankAccount from './singleBankAccount';
import withPermissions from '../../../auth/utils/withPermissions';
import ShowCard from '../paymentCard/containers/showCard';
import DebitCard from '../debitCard';
import Invoices from '../subscription/components/Invoices';

const NoBankAccount = () => (
  <div className="o-flexbox">
    <div className="o-flexbox__item">
      <h4>No bank account.</h4>
    </div>
  </div>
);

class BankAccount extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bankAccount: null,
      isLoading: true,
    };
  }

  componentDidMount() {
    this.fetchAccount();
  }

  fetchAccount() {
    this.props.fetchAccount()
      .then(() => this.setState({
        isLoading: false,
      }));
    this.props.fetchDebitCard();
    this.props.fetchBalance();
  }

  render() {
    if (this.state.isLoading) return null;
    const {
      bankAccount,
      permissions,
      debitCard,
      total,
      shouldShowDebitCard,
    } = this.props;

    return (
      <div className="c-wrapper">
        <div className="u-max-width-710 u-margin-auto u-mv-">
          <div className="c-heading c-heading--small">
            You cannot receive payment unless you provide complete and accurate checking account
            information. Incomplete accounts run the risk of being suspended, delaying your receipt
            of payment. Once your checking account is properly set up, transfers to your checking
            account will take 1-2 business days after the service is completed or a sale is made. To
            receive your funds on the day of the service or sale, you can activate &quot;Instant
            Payout&quot; by first adding a checking account, then adding a debit card connected to
            your checking account. Rapid Transfer transactions incur an additional fee of 2.0% of
            the transferred amount.
          </div>
        </div>
        <div className="c-inner-wrapper u-max-width-710 u-mt-">
          <NoBankAccount display-if={!bankAccount} />
          <SingleBankAccount
            display-if={bankAccount}
            account={bankAccount}
            deleteAccount={this.props.deleteAccount}
          />
          <div
            className="u-text-right"
            display-if={canUserAddBankAccounts(permissions) && !bankAccount}
          >
            <AddBarberPrefix
              className="c-btn"
              to="/settings/bank-account/add"
            >
              Add bank account
            </AddBarberPrefix>
          </div>
        </div>
        <DebitCard display-if={shouldShowDebitCard && bankAccount} card={debitCard} />
        <div className="c-inner-wrapper u-max-width-710 u-mt-" display-if={shouldShowDebitCard && debitCard}>
          <div>
            Available Balance:<br />
            <Money>{total}</Money>
          </div>
        </div>
        <div className="c-inner-wrapper u-max-width-710 u-mt-">
          <ShowCard />
        </div>
        <div className="c-inner-wrapper u-max-width-710 u-mt-">
          <Invoices />
        </div>
      </div>
    );
  }
}

BankAccount.propTypes = {
  fetchAccount: PropTypes.func.isRequired,
  deleteAccount: PropTypes.func.isRequired,
  permissions: PropTypes.object.isRequired,
  bankAccount: PropTypes.object,
  debitCard: PropTypes.object,
  fetchDebitCard: PropTypes.func,
  total: PropTypes.number,
  fetchBalance: PropTypes.func,
  shouldShowDebitCard: PropTypes.bool.isRequired,
};
BankAccount.defaultProps = {
  bankAccount: null,
  debitCard: null,
  fetchDebitCard: () => {},
  total: 0,
  initiateInstantPayout: () => {},
  fetchBalance: () => {},
};

const mapStateToProps = state => ({
  bankAccount: state.settings.bankAccount,
  debitCard: state.settings.debitCard,
  total: getTotalBalance(state),
  instantPayoutIsFetching: getInstantPayoutIsFetching(state),
  shouldShowDebitCard: getShouldShowDebitCard(state),
});

export default connect(
  mapStateToProps
)(withPermissions(BankAccount));
